/* @flow */

import classNames from 'classnames';
import { compose } from 'ramda';
import * as React from 'react';
import { createUseStyles } from 'react-jss';

import BaseIcon from 'src/shared/ui/component/icon/BaseIcon';
import styles from './StarIcon.style';

import svg from './star.svg';

type Props = {
  className?: string,
  title?: string,
  isFilled?: boolean,
  large?: boolean,
};

const useStyles = createUseStyles(styles);

const StarIcon = ({ className, title, isFilled, large }: Props): React.Node => {
  const classes: Object = useStyles();

  // Classes

  const rootClasses = classNames(classes.root, className, {
    [classes['root-isFilled']]: isFilled,
    [classes['root-large']]: large,
  });

  return <BaseIcon className={rootClasses} svg={svg} title={title} />;
};

export default compose(React.memo)(StarIcon);
